import { PolymorphicButtonProps, usePolymorphicButtonProps } from '@nucleus/react-components';
import React from 'react';
import styled from 'styled-components';
import { cornerStyleInterpolationFactory } from '../lib/cornerStyle';

declare module '@nucleus/sermon-theme-elements' {
  interface SermonThemeElementsTheme {
    NavItem?: {
      className?: string;
      color?: string;
      background?: string;
      fontSize?: string;
      lineHeight?: string;
      active?: {
        color?: string;
        background?: string;
      };
      hover?: {
        color?: string;
        background?: string;
      };
    };
  }
}

export type NavItemProps = PolymorphicButtonProps;

export const NavItem = (props: NavItemProps): JSX.Element => {
  return (
    <Item>
      <Button {...usePolymorphicButtonProps(props)}>{props.children}</Button>
    </Item>
  );
};

const Item = styled.li``;

const Button = styled.button.attrs((props) => ({
  className: props.theme._sermonThemeElements.NavItem?.className,
}))`
  color: ${({ theme }) => theme._sermonThemeElements.NavItem?.color};
  background: ${({ theme }) => theme._sermonThemeElements.NavItem?.background};
  border: none;
  border-radius: ${cornerStyleInterpolationFactory({
    square: '0px',
    rounded: '7px',
    pill: '18px',
  })};
  font-size: ${({ theme }) => theme._sermonThemeElements.NavItem?.fontSize};
  line-height: ${({ theme }) => theme._sermonThemeElements.NavItem?.lineHeight};
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  user-select: none;
  cursor: pointer;
  height: 36px;
  padding: 0px 12.5px;
  text-decoration: none;

  && {
    margin: 0;
  }

  /* Always use the the Hover state on mobile */
  @media (max-width: 600px) {
    color: ${({ theme }) => theme._sermonThemeElements.NavItem?.hover?.color};
    background: ${({ theme }) => theme._sermonThemeElements.NavItem?.hover?.background};
  }

  :hover {
    color: ${({ theme }) => theme._sermonThemeElements.NavItem?.hover?.color};
    background: ${({ theme }) => theme._sermonThemeElements.NavItem?.hover?.background};
  }

  :active,
  &.active {
    color: ${({ theme }) => theme._sermonThemeElements.NavItem?.active?.color};
    background: ${({ theme }) => theme._sermonThemeElements.NavItem?.active?.background};
  }
`;
